import passwordRouter from './passwordRouter';

export default passwordRouter;
